import React from "react";
import { InlineMath, BlockMath } from "react-katex";


export function renderStatementWithKaTeX(statement="Unfortunatly there is no problem available at the moment ...") {
  const elements = [];
  const regex = /\$\$([^$]+?)\$\$|\$([^$]+?)\$|\\\(([^)]+?)\\\)/gs;
  let lastIndex = 0;

  // Helper to turn newlines into <br />
  const renderTextWithLineBreaks = (text, keyPrefix) => {
    return text.split("\n").map((part, i) => (
      <React.Fragment key={`${keyPrefix}-${i}`}>
        {part}
        {i < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  for (const match of statement.matchAll(regex)) {
    const [fullMatch, blockMath, inlineMath1, inlineMath2] = match;
    const matchStart = match.index;

    // Add any text before the match
    if (matchStart > lastIndex) {
      elements.push(
        <span key={lastIndex}>
          {renderTextWithLineBreaks(statement.slice(lastIndex, matchStart), lastIndex)}
        </span>
      );
    }

    // Render math
    if (blockMath !== undefined) {
      elements.push(
  <div key={matchStart} className="block-math-scroll">
    <BlockMath>{blockMath.trim()}</BlockMath>
  </div>
);
    } else {
      const inlineContent = inlineMath1 || inlineMath2;
      elements.push(<InlineMath key={matchStart}>{inlineContent.trim()}</InlineMath>);
    }

    lastIndex = matchStart + fullMatch.length;
  }

  // Add remaining text after last match
  if (lastIndex < statement.length) {
    elements.push(
      <span key={lastIndex}>
        {renderTextWithLineBreaks(statement.slice(lastIndex), lastIndex)}
      </span>
    );
  }

  return elements;
}
